module.exports = __webpack_public_path__ + "static/media/the_1.bca5d994.png";